import { useSyncExternalStore } from 'react';
import { isPageInForeground, subscribePageForeground } from './page_foreground.ts';

// Whether the page is in the foreground; a focus is not part of it (page_foreground.ts decides what counts)
export function useIsAppActive() {
  return useSyncExternalStore(subscribePageForeground, isPageInForeground);
}
